import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'

const deleteMyMonitoringControl = async (controlId: number): Promise<boolean> =>
  axios.delete(`/my-monitoring/control/RemoveControl?controlId=${controlId}`).then((res) => res?.data?.result)

type Props = {
  controlId: number
}

export const useMyMonitoringDeleteControl = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['deleteMyMonitoringControl'],
    mutationFn: ({ controlId }: Props) => deleteMyMonitoringControl(controlId),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Removed control.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to remove control, please try again.')
      }
    },
    throwOnError: false
  })
